import { render, staticRenderFns } from "./ProfileOderDetail.vue?vue&type=template&id=594dd861&scoped=true&"
import script from "./ProfileOderDetail.vue?vue&type=script&lang=js&"
export * from "./ProfileOderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProfileOderDetail.vue?vue&type=style&index=0&id=594dd861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594dd861",
  null
  
)

export default component.exports